<div [ngClass]="['cell', resourcesCssService.responsiveClass()]">
  <div class='header'>
    <div class='badge'>
      <button (click)='play()'><i class="mt-play-selected"></i></button>
    </div>
    <div class='thumbnail'>
      <!-- <ion-img [src]='video.mediaImage ? video.mediaImage : "assets/imgs/placeholder.png"' [style.opacity]='loaded ? 1.0 : 0.0' (ionImgDidLoad)='load()'></ion-img> -->
    </div>
  </div>
  <div class='info'>
    <h2 class='title' (click)='play()'>{{ video.name }}</h2>
    <div class='description' [innerHTML]="video.description"></div>
    <p class='types' [hidden]='true'>{{ video.types | split | concat:" • " }}</p>
  </div>
</div>